import { useState, useEffect } from 'react'
import {labelValueArrayToObject} from "../../util";
import {AgencyProfessionCodes} from "./AgencyProfessionCodes";
const AgencyLicenseConfig = props => {

  const {
    value,
  } = props


  const allProfessionsIndexed = labelValueArrayToObject( window.tgblCredProfessions );
  const profCodesToLabelValue = (profCodes) => profCodes.map((professionIdCode) => ({
    value: professionIdCode.id,
    label: allProfessionsIndexed[professionIdCode.id]
  })).filter( labelVal => !!labelVal.label );


  const [regions, setRegions] = useState(value.regions ?? [])
  const [professions, setProfessions] = useState( profCodesToLabelValue(value.profession_codes ?? []) );

  // const [allRegionsEverAdded, setAllRegionsEverAdded] = useState(regions);
  // useEffect(() => {
  //   tangibleFields.fields.rerender('agency_license_fields')
  // }, [regions]);
  // useEffect(() => {
  //   console.warn('BIBIBMPAPPPPPPP===========-');
  // }, [professions]);

  const restrictLicenseMultiSelects = (licenseFields, regions, professions) => {
    //licenseFields.i.region is a comma-separated string
    licenseFields = licenseFields || [];

    const validRegions = regions.reduce((obj, region) => {
      obj[region.value] = true;
      return obj;
    }, {});
    const validProfs = professions.reduce((obj, region) => {
      obj[region.value] = true;
      return obj;
    }, {});

    return licenseFields.map(licenseField => {
      // Split the regions by comma to get individual region ids
      let regionIds;
      let profIds;

      regionIds = "string" === typeof licenseField.regions
        ? licenseField.regions?.split(',') ?? []
        : licenseField.regions;

      profIds = "string" === typeof licenseField.professions
        ? licenseField.professions?.split(',') ?? []
        : licenseField.professions

      const restrictedRegions = regionIds.filter(regionId => validRegions[regionId]);
      const restrictedProfessions = profIds.filter(profId => validProfs[profId]);

      // Recombine the valid region ids into a comma-separated string
      licenseField.regions = restrictedRegions.join(',');
      licenseField.professions = restrictedProfessions.join(',');

      // Return the updated license field object
      return licenseField;
    });
  };

  const regionsSelect = tangibleFields.render({
    type: 'combo-box',
    name: 'tgbl_cred_agency_regions_served',
    value: regions,
    multiple: true,
    isAsync: true,
    ajaxAction: 'tgbl_get_terms_ajax',
    asyncArgs: {
      content_type: 'tgbl_cred_region'
    },
    label: 'Regions',
    onChange: (regions) => {
      setRegions(regions);
      // const newRegionsEverAdded = [...allRegionsEverAdded];
      // regions.forEach(region => {
      //   if (!newRegionsEverAdded.includes(region)) {
      //     newRegionsEverAdded.push(region);
      //   }
      // });
      // setAllRegionsEverAdded(newRegionsEverAdded);
    },
    description: 'The region(s) which this accrediting agency serves.',
  })

  const professionCodeList = tangibleFields.render({
    type: 'repeater',
    name: 'profession_codes',
    value: value.profession_codes,
    layout: 'table',
    sectionTitle: 'Content',
    fields: [{
      type: 'combo-box',
      name: 'id',
      label: 'Profession',
      choices: allProfessionsIndexed,
    }, {
      type: 'text',
      name: 'code',
      label: 'Code'
    }],
    onChange: function(professionCodes) {

      if( ! professionCodes ) return;

      let newProfIds = professionCodes.map(profCode => profCode.id).filter(id => !!id).sort(),
        oldProfIds = professions.map(prof => prof.value).sort(),
        profsChanged = false;

      if( oldProfIds.length !== newProfIds.length ) {
        profsChanged = true;
      } else {
        profsChanged = !oldProfIds.every((id, index) => id === newProfIds[index]);
      }

      if( profsChanged ) {
        setProfessions( profCodesToLabelValue(professionCodes.filter(profCode => !!profCode.id )) );
      }
    }
  })

  const licenseFields = value.license_fields?.length ? value.license_fields: [];
  tangibleFields.store.setValue(
    'agency_license_fields',
    restrictLicenseMultiSelects(
      tangibleFields.store.getValue('agency_license_fields'),
      regions,
      professions
    )
  );

  const licensesFieldsRepeater = tangibleFields.render({
    type: 'repeater',
    name: 'agency_license_fields',
    value: licenseFields,
    layout: 'block',
    sectionTitle: 'Regional License Numbers',
    fields: [
      {
        type: 'text',
        name: 'label',
        label: 'Field'
      },
      {
        type: 'text',
        name: 'prefix',
        label: 'Prefix'
      },
      {
        type: 'text',
        name: 'mask',
        label: 'Mask'
      },
      {
        type: 'text',
        name: 'suffix',
        label: 'Suffix'
      },
      {
        type: 'combo-box',
        name: 'professions',
        label: 'Professions',
        multiple: true,
        choices: labelValueArrayToObject(professions)
      },
      {
        type: 'combo-box',
        name: 'regions',
        label: 'Regions',
        multiple: true,
        choices: labelValueArrayToObject(regions),
      },
      {
        type: 'switch',
        name: 'collect_renewal_date',
        label: 'Collect renewal date',
        value_on: 'on',
        value_off: 'off',
      }
    ],
    wrapper : {
      class: 'agency-regional-license-repeater'
    }
  })

  return (
    <>
      <div className="tgbl-cred-agency-regions tgbl-field-block">
        {regionsSelect}
      </div>
      <div className="tgbl-agency-accreditation-fields-block tgbl-field-block">
        <div className="tgbl-block-title"><h2>Professions</h2></div>
        <div className="tf-pseudo-description">Custom profession-specific codes for this Agency</div>
        {professionCodeList}
      </div>
      <div className=" tgbl-cred-agency-regional-licenses tgbl-field-block">
        {licensesFieldsRepeater}
      </div>
    </>
  )
}

export {AgencyLicenseConfig}
